import React, { useEffect, useState } from "react"
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    Button,
    Table,
    Modal,
    ModalHeader,
    ModalBody,
    Form,
    FormGroup,
    Label,
    Input,
    UncontrolledTooltip,
} from "reactstrap"
import { connect } from "react-redux"
import {
    setBreadcrumbItems,
    getSuppliers,
    addNewSupplier,
    updateSupplier,
    deleteSupplier
} from "../../store/actions"
import { useFormik } from "formik"
import * as Yup from "yup"

const Suppliers = props => {
    document.title = "Fournisseurs | CRM Entreprise"

    const { suppliers, getSuppliers, addNewSupplier, updateSupplier, deleteSupplier } = props
    const [modal, setModal] = useState(false)
    const [isEdit, setIsEdit] = useState(false)
    const [currentSupplier, setCurrentSupplier] = useState(null)

    const breadcrumbItems = [
        { title: "Fournisseurs", link: "#" },
        { title: "Liste", link: "#" },
    ]

    useEffect(() => {
        props.setBreadcrumbItems("Fournisseurs", breadcrumbItems)
        getSuppliers()
    }, [])

    const toggle = () => {
        setModal(!modal)
        if (modal) {
            setIsEdit(false)
            setCurrentSupplier(null)
        }
    }

    const handleEdit = (supplier) => {
        setCurrentSupplier(supplier)
        setIsEdit(true)
        setModal(true)
    }

    const handleDelete = (id) => {
        if (window.confirm("Êtes-vous sûr de vouloir supprimer ce fournisseur ?")) {
            deleteSupplier(id)
        }
    }

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            name: (currentSupplier && currentSupplier.name) || "",
            email: (currentSupplier && currentSupplier.email) || "",
            phone: (currentSupplier && currentSupplier.phone) || "",
            address: (currentSupplier && currentSupplier.address) || "",
            tax_id: (currentSupplier && currentSupplier.tax_id) || "",
            notes: (currentSupplier && currentSupplier.notes) || "",
        },
        validationSchema: Yup.object({
            name: Yup.string().required("Le nom est obligatoire"),
            email: Yup.string().email("Email invalide"),
        }),
        onSubmit: (values) => {
            if (isEdit) {
                updateSupplier({ id: currentSupplier.id, ...values })
            } else {
                addNewSupplier(values)
            }
            toggle()
        },
    })

    return (
        <React.Fragment>
            <div className="container-fluid">
                <Row>
                    <Col lg="12">
                        <Card>
                            <CardBody>
                                <div className="d-flex align-items-center mb-4">
                                    <div className="flex-grow-1">
                                        <h4 className="card-title">Mes Fournisseurs</h4>
                                    </div>
                                    <div className="flex-shrink-0">
                                        <Button color="primary" onClick={toggle}>
                                            <i className="mdi mdi-plus me-1"></i> Nouveau Fournisseur
                                        </Button>
                                    </div>
                                </div>

                                <div className="table-responsive">
                                    <Table className="table-centered table-nowrap mb-0">
                                        <thead className="table-light">
                                            <tr>
                                                <th>Nom</th>
                                                <th>Contact</th>
                                                <th>ICE / Tax ID</th>
                                                <th>Adresse</th>
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {(suppliers.data || []).map((supplier, key) => (
                                                <tr key={key}>
                                                    <td>
                                                        <div className="d-flex align-items-center">
                                                            <div className="avatar-xs me-3">
                                                                <span className="avatar-title rounded-circle bg-primary-subtle text-primary">
                                                                    {supplier.name.charAt(0)}
                                                                </span>
                                                            </div>
                                                            <div>
                                                                <h5 className="font-size-14 mb-1 text-dark">{supplier.name}</h5>
                                                                <p className="text-muted mb-0">{supplier.email}</p>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>{supplier.phone}</td>
                                                    <td>{supplier.tax_id}</td>
                                                    <td>{supplier.address}</td>
                                                    <td>
                                                        <div className="d-flex gap-3">
                                                            <span className="text-success" onClick={() => handleEdit(supplier)} style={{ cursor: 'pointer' }}>
                                                                <i className="mdi mdi-pencil font-size-18" id="edittooltip"></i>
                                                                <UncontrolledTooltip placement="top" target="edittooltip">Modifier</UncontrolledTooltip>
                                                            </span>
                                                            <span className="text-danger" onClick={() => handleDelete(supplier.id)} style={{ cursor: 'pointer' }}>
                                                                <i className="mdi mdi-delete font-size-18" id="deletetooltip"></i>
                                                                <UncontrolledTooltip placement="top" target="deletetooltip">Supprimer</UncontrolledTooltip>
                                                            </span>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                            {(!suppliers.data || suppliers.data.length === 0) && (
                                                <tr>
                                                    <td colSpan="5" className="text-center">Aucun fournisseur trouvé.</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </Table>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                {/* Modal for Add/Edit Supplier */}
                <Modal isOpen={modal} toggle={toggle}>
                    <ModalHeader toggle={toggle}>
                        {isEdit ? "Modifier Fournisseur" : "Ajouter Fournisseur"}
                    </ModalHeader>
                    <ModalBody>
                        <Form onSubmit={(e) => { e.preventDefault(); formik.handleSubmit(); }}>
                            <Row>
                                <Col lg="12">
                                    <FormGroup className="mb-3">
                                        <Label>Nom / Entreprise</Label>
                                        <Input
                                            name="name"
                                            type="text"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.name}
                                            invalid={formik.touched.name && formik.errors.name ? true : false}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col lg="6">
                                    <FormGroup className="mb-3">
                                        <Label>Email</Label>
                                        <Input
                                            name="email"
                                            type="email"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.email}
                                            invalid={formik.touched.email && formik.errors.email ? true : false}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col lg="6">
                                    <FormGroup className="mb-3">
                                        <Label>Téléphone</Label>
                                        <Input
                                            name="phone"
                                            type="text"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.phone}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col lg="12">
                                    <FormGroup className="mb-3">
                                        <Label>ICE / Tax ID</Label>
                                        <Input
                                            name="tax_id"
                                            type="text"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.tax_id}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col lg="12">
                                    <FormGroup className="mb-3">
                                        <Label>Adresse</Label>
                                        <Input
                                            name="address"
                                            type="textarea"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.address}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col lg="12">
                                    <FormGroup className="mb-3">
                                        <Label>Notes</Label>
                                        <Input
                                            name="notes"
                                            type="textarea"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.notes}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <div className="text-end">
                                <Button type="submit" color="primary">
                                    {isEdit ? "Enregistrer" : "Ajouter"}
                                </Button>
                            </div>
                        </Form>
                    </ModalBody>
                </Modal>

            </div>
        </React.Fragment >
    )
}

const mapStateToProps = ({ Suppliers }) => ({
    suppliers: Suppliers.suppliers,
})

export default connect(mapStateToProps, {
    setBreadcrumbItems,
    getSuppliers,
    addNewSupplier,
    updateSupplier,
    deleteSupplier
})(Suppliers)
